import CheckoutForm from '../layouts/checkout/CheckoutForm';
import HeaderTwo from '../../common/header/HeaderTwo';
import FooterOne from '../../common/footer/FooterOne';

const Checkout = () => {
    return (
        <div className="">       
            <HeaderTwo />       
                <CheckoutForm />
            <FooterOne />
        </div>
    );
}

export default Checkout;